import Cookies                                                                       from "js-cookie";
import { PAYTM_MINI_APP, PAYTM_MINI_APP_TITLE, PAYTM_TAB }                           from "_config/index";
import { checkForPaytmMiniApp, getPaytmMiniAppAccessToken, getPaytmMiniAppUserData } from "./paytm-mini-app";
import { getUserProfile }                                                            from "_services/api/user";
import { getUserData, storeUserDataCookie }                                          from "_common/utils/user";
/* import { setUserProfile }                                                            from "_redux/slices/auth"; */
import Toast  from "_common/toast";
import Router from "next/router";

// checks if web app is loaded inside any thid party environment
export const isInsideThirdPartyApp = query => {
	if ( query ) {
		// check from query params
		return checkViaQuery ( query );
	} else if ( process.browser ) {
		// alert(`chechking env`);
		// check from cookies or individaul constraints for all third party integrations
		if ( checkForPaytmMiniApp () ) {
			return PAYTM_MINI_APP;
		}
	}
};
export const thirdPartyTitle = appName => {
	switch ( appName ) {
		case PAYTM_MINI_APP:
			return PAYTM_MINI_APP_TITLE;

		default:
			return PAYTM_MINI_APP_TITLE;
	}
};
export const loginThirdPartyUser = async props => {
	const { dispatch, appName } = props;
	const { router }            = Router;
	const { query }             = router;
	const PowerPlayAndroid      = window?.PowerPlayAndroid;

	switch ( appName ) {
		case PAYTM_MINI_APP: {
			await getPaytmMiniAppAccessToken ( { executeAuthActions, dispatch } );
			break;
		}

		case PAYTM_TAB: {
			const property    = query.property ? query.property : "PP_WEB";
			const accessToken = query.access_token || query.mv_cas_oauth_token;
			let device_id     = query.device_id;
			// let uuid = Cookies.get("rooter_pwa_uuid");
			// mv_cas_oauth_token is not available

			if ( !device_id ) {
				if ( typeof PowerPlayAndroid.getAppInfo !== "function" ) {
					capturePaytmError ( { title: "PowerPlayAndroid.getAppInfo is not available", message: "" } );
					PowerPlayAndroid.onCASError ();
				}
				let appData = PowerPlayAndroid.getAppInfo ();

				appData   = JSON.parse ( appData );
				device_id = appData.device_id;
			}

			if ( !accessToken || !device_id ) {
				capturePaytmError ( { title: "mv_cas_oauth_token is not available", message: "" } );
				PowerPlayAndroid.onCASError ();
			}
			// PowerPlayAndroid.getAppInfo is not available

			// if (!uuid || uuid === "undefined") {
			//   uuid = uuidv1(); // this runs for the very first time when there is no uuid
			// }
			await executeAuthActions ( { dispatch, tokenData: { property, accessToken, openId: device_id }, appName } );
		}
	}
};
const executeAuthActions = async props => {
	const { dispatch, tokenData, appName } = props;
	let result, userProfileData;
	const PowerPlayAndroid                 = window?.PowerPlayAndroid;

	try {
		result = await getPaytmMiniAppUserData ( tokenData );
		// alert(JSON.stringify(result, "profile data"));
		if ( result ) {
			const authData = { ...result, uuid: tokenData.openId, isLoggedIn: true };

			userProfileData = await getUserProfile ( authData );

			if ( typeof userProfileData === "number" )
				userProfileData = null;

			if ( userProfileData ) {
				storeUserDataCookie ( authData );

				/* dispatch ( setUserProfile ( userProfileData ) ); */
			}
		}
	} finally {
		if ( !result || !userProfileData ) {
			if ( appName === PAYTM_TAB ) {
				capturePaytmError ( { title: "Auth or profile data not available", message: "" } );
				PowerPlayAndroid.onCASError ();
			}
			if ( getUserData () ) {
				Toast.error ( "Error while logging in, please try again" );
			} else {
				// do nothing
			}
		}
	}
};

function checkViaQuery ( query ) {
	const { external_env } = query;

	// check for paytm mini app
	if ( external_env ) {
		return external_env;
	}

	return;
}
export const setThirdPartyCookie = appName => {
	if ( !Cookies.get ( "external_env" ) ) {
		Cookies.set ( "external_env", appName, { expires: 365 } );
	}
};
const capturePaytmError = ( { title, message } ) => {
	const errObject = new Error ();

	errObject.name    = title;
	errObject.message = message;
};
